import React from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { Throbber } from '@lt/components';
import { useTranslation } from '@lt/localization';

import type { Hotels } from '../../../Hotels/types';
import ShowMorePenalizedHotels from '../ShowMorePenalizedHotels';
import HotelRenderer from '../../../HotelRenderer';

interface IPenalizedHotels {
  hotels: Hotels;
  isMobile?: boolean;
  visibleLimit: number;
}

export const PenalizedHotels = (props: IPenalizedHotels) => {
  const { hotels, isMobile = false, visibleLimit } = props;

  const { t } = useTranslation();

  if (isEmpty(hotels)) return null;

  return (
    <Wrapper>
      <Title>
        {t('search.penalizedHotels.titleFirstRow')}
        {!isMobile && <br />} {t('search.penalizedHotels.titleSecondRow')}
      </Title>

      <LoaderContainer>
        <Loader color="#444" size={30} />
      </LoaderContainer>

      <PenalizedHotelsList>
        {hotels
          .slice(0, visibleLimit)
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .map(({ analyticsInfo, ...hotel }) => (
            <Item key={hotel.tourId}>
              <HotelRenderer
                {...hotel}
                isMapCard={false}
                key={hotel.tourId}
                isMobile={isMobile}
              />
            </Item>
          ))}

        <ShowMorePenalizedHotels />
      </PenalizedHotelsList>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-bottom: 40px;
`;

const LoaderContainer = styled.div`
  position: relative;
`;

const Loader = styled(Throbber)`
  top: 20px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 22px;
  color: #17181a;
  margin: 24px 8px 16px;
`;

const PenalizedHotelsList = styled.ul`
  padding: 0 8px;
`;

const Item = styled.li`
  margin-bottom: 8px;
  max-width: 100vw;
  position: relative;
`;
